import { LeaveStateProps } from './MyTeams.types';
import styles from './MyTeams.module.scss';
import { PureTableRow } from '../../../common/PureTable/PureTable.types';
import { getRemoveColumn } from '../../../common/PureTable/PureTable.utils';

export const mapTeamToTableRow =
  <T extends { id: string; canLeaveTeam?: boolean }>(
    props: (keyof T)[],
    { onBinClickHandler, itemsLeavingState }: LeaveStateProps = {},
  ) =>
  (acc: Record<string, PureTableRow>, curr: T): Record<string, PureTableRow> => {
    if (props.length === 1) {
      return {
        ...acc,
        [curr.id]: [
          <span key={`${curr.id}|${curr[props[0]]}`} className={styles.tableRow}>
            <span>{props.map(prop => curr[prop] as string).join()}</span>
            {getRemoveColumn({
              onBinClickHandler,
              itemsRemovingState: itemsLeavingState,
              id: curr.id,
              canRemove: curr.canLeaveTeam ?? false,
              titleKey: 'delete.leaveTeam',
              individual: false,
            })}
          </span>,
        ],
      };
    }

    return {
      ...acc,
      [curr.id]: props.map(prop => curr[prop] as string),
    };
  };
